module.exports = __webpack_public_path__ + "img/hr-puberty-decal-21.8ac00bc2.png";